// =============================================================================
// SEO DATA AND STRUCTURED DATA
// =============================================================================

export const businessStructuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Awani",
  "description": "Luxury custom clothing made from organic alpaca wool. High-end fashion that combines timeless elegance with sustainable practices.",
  "url": "https://awani.earth",
  "logo": "https://awani.earth/images/logo.png",
  "image": "https://awani.earth/images/logo.png",
  "foundingDate": "2024",
  "founder": {
    "@type": "Person",
    "name": "Awani",
    "jobTitle": "Luxury Fashion Designer",
    "description": "Creating timeless, sustainable luxury clothing from the finest organic alpaca wool.",
    "url": "https://awani.earth/about",
    "image": "https://awani.earth/images/logo.png"
  },
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "US"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "url": "https://awani.earth/contact"
  },
  "serviceArea": {
    "@type": "Place",
    "name": "Worldwide Shipping Available"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Awani Luxury Alpaca Wool Collections",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Essential Collection",
          "description": "Timeless alpaca wool pieces for everyday wear. Classic sweaters, cardigans, and wraps in natural colors.",
          "provider": {
            "@type": "Organization",
            "name": "Awani"
          }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Luxury Collection",
          "description": "Elevated designs for special occasions. Exquisite alpaca wool pieces with premium details and sophisticated silhouettes.",
          "provider": {
            "@type": "Organization",
            "name": "Awani"
          }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Custom Made-to-Order",
          "description": "Personalized alpaca wool garments tailored to your exact measurements and style preferences. The ultimate in luxury fashion.",
          "provider": {
            "@type": "Organization",
            "name": "Awani"
          }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Limited Edition Pieces",
          "description": "Exclusive limited-run alpaca wool designs featuring unique colors, textures, and one-of-a-kind details.",
          "provider": {
            "@type": "Organization",
            "name": "Awani"
          }
        }
      }
    ]
  }
};

export const personStructuredData = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Awani",
  "jobTitle": "Luxury Fashion Designer",
  "description": "Creating timeless, sustainable luxury clothing from the finest organic alpaca wool. Specializes in custom-made garments and sustainable fashion.",
  "url": "https://awani.earth/about",
  "image": "https://awani.earth/images/logo.png",
  "knowsAbout": [
    "Luxury Fashion",
    "Alpaca Wool",
    "Sustainable Fashion",
    "Custom Tailoring",
    "Organic Fibers",
    "Ethical Sourcing",
    "Artisan Craftsmanship",
    "Natural Dyeing",
    "Timeless Design"
  ],
  "hasOccupation": {
    "@type": "Occupation",
    "name": "Luxury Fashion Designer",
    "description": "Creates exceptional custom clothing from organic alpaca wool, combining timeless design with sustainable practices.",
    "occupationLocation": {
      "@type": "Place",
      "name": "Worldwide"
    }
  }
};

export const websiteStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Awani",
  "description": "Luxury custom clothing made from organic alpaca wool. High-end sustainable fashion.",
  "url": "https://awani.earth",
  "publisher": {
    "@type": "Organization",
    "name": "Awani",
    "logo": {
      "@type": "ImageObject",
      "url": "https://awani.earth/images/logo.png",
      "width": 1024,
      "height": 1024,
      "caption": "Awani Logo"
    }
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://awani.earth/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const serviceStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Awani Luxury Collections",
  "description": "Luxury custom clothing and ready-to-wear collections made from organic alpaca wool. Sustainable fashion with timeless design.",
  "provider": {
    "@type": "Organization",
    "name": "Awani",
    "url": "https://awani.earth"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Worldwide"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Awani Collections & Custom Craftsmanship",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Essential Collection",
          "description": "Timeless alpaca wool pieces for everyday wear",
          "image": "https://awani.earth/images/essential-collection.jpg"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Luxury Collection",
          "description": "Elevated designs for special occasions",
          "image": "https://awani.earth/images/luxury-collection.jpg"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Custom Made-to-Order",
          "description": "Personalized garments tailored to your measurements",
          "image": "https://awani.earth/images/custom-collection.jpg"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Limited Edition",
          "description": "Exclusive limited-run designs",
          "image": "https://awani.earth/images/limited-edition.jpg"
        }
      }
    ]
  }
};

// Service-specific structured data for better SEO
export const serviceImagesStructuredData = {
  "@context": "https://schema.org",
  "@type": "ImageGallery",
  "name": "Awani Luxury Collections",
  "description": "Visual representation of our luxury alpaca wool collections: Essential pieces, luxury designs, custom made-to-order, and limited editions.",
  "url": "https://awani.earth/collections",
  "image": [
    {
      "@type": "ImageObject",
      "url": "https://awani.earth/images/logo.png",
      "name": "Essential Collection",
      "description": "Timeless alpaca wool pieces for everyday wear",
      "width": 1024,
      "height": 1024
    },
    {
      "@type": "ImageObject",
      "url": "https://awani.earth/images/logo.png",
      "name": "Luxury Collection",
      "description": "Elevated designs for special occasions",
      "width": 1024,
      "height": 1024
    },
    {
      "@type": "ImageObject",
      "url": "https://awani.earth/images/logo.png",
      "name": "Custom Made-to-Order",
      "description": "Personalized garments tailored to your measurements",
      "width": 1024,
      "height": 1024
    },
    {
      "@type": "ImageObject",
      "url": "https://awani.earth/images/logo.png",
      "name": "Limited Edition Pieces",
      "description": "Exclusive limited-run designs",
      "width": 1024,
      "height": 1024
    }
  ]
};

// Page-specific SEO data
export const seoData = {
  home: {
    title: "Awani - Luxury Alpaca Wool Clothing | Sustainable High-End Fashion",
    description: "Discover luxury custom clothing made from the finest organic alpaca wool. Timeless designs, sustainable practices, and exceptional craftsmanship. Shop our Essential, Luxury, and Custom Made-to-Order collections.",
    keywords: "alpaca wool, luxury clothing, sustainable fashion, organic fibers, custom clothing, high-end fashion, alpaca sweaters, sustainable luxury, ethical fashion, handmade clothing, natural fibers",
    canonicalUrl: "/",
    structuredData: [businessStructuredData, websiteStructuredData, serviceStructuredData, serviceImagesStructuredData]
  },
  about: {
    title: "About Awani - Sustainable Luxury Fashion | Our Story",
    description: "Learn about Awani's commitment to creating luxury clothing from organic alpaca wool. Discover our story, values, and the artisans who bring our designs to life.",
    keywords: "Awani, sustainable fashion, luxury clothing, alpaca wool, ethical fashion, organic fibers, artisan craftsmanship, sustainable luxury, fashion brand",
    canonicalUrl: "/about",
    structuredData: [personStructuredData, businessStructuredData]
  },
  services: {
    title: "Awani Collections - Luxury Alpaca Wool Clothing",
    description: "Explore our curated collections of luxury alpaca wool clothing. Essential pieces for everyday wear, luxury designs for special occasions, and custom made-to-order garments tailored to you.",
    keywords: "alpaca wool clothing, luxury collections, essential collection, luxury collection, custom clothing, made-to-order, sustainable fashion, organic alpaca, luxury sweaters",
    canonicalUrl: "/collections",
    structuredData: [serviceStructuredData, businessStructuredData, serviceImagesStructuredData]
  },
  contact: {
    title: "Contact Awani - Start Your Custom Order or Ask Questions",
    description: "Get in touch with Awani to start your custom order, ask questions about our collections, or learn more about our luxury alpaca wool clothing. We respond within 24 hours.",
    keywords: "contact Awani, custom order, alpaca wool clothing, luxury fashion inquiry, fashion consultation, clothing questions",
    canonicalUrl: "/contact",
    structuredData: [businessStructuredData]
  },
  payment: {
    title: "Payment - Complete Your Awani Order",
    description: "Secure payment for your Awani luxury alpaca wool clothing. Complete your order for ready-to-wear pieces or custom made-to-order garments.",
    keywords: "payment, Awani order, luxury clothing payment, alpaca wool purchase",
    canonicalUrl: "/payment",
    noIndex: true
  },
  privacy: {
    title: "Privacy Policy - Awani Luxury Fashion",
    description: "Privacy policy for Awani. Learn how we collect, use, and protect your personal information when you shop with us or place a custom order.",
    keywords: "privacy policy, data protection, Awani privacy, fashion brand privacy",
    canonicalUrl: "/privacy",
    noIndex: true
  },
  terms: {
    title: "Terms of Service - Awani Luxury Fashion",
    description: "Terms of service for Awani. Read our terms and conditions for purchasing luxury alpaca wool clothing, custom orders, and returns.",
    keywords: "terms of service, terms and conditions, Awani terms, fashion brand terms, clothing purchase terms",
    canonicalUrl: "/terms",
    noIndex: true
  },
  notfound: {
    title: "404 - Page Not Found | Awani",
    description: "The page you're looking for doesn't exist. Browse our luxury alpaca wool collections or contact us for custom orders.",
    keywords: "404, page not found, Awani",
    canonicalUrl: "/404",
    noIndex: true
  }
};
